/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Collection from './collection'
import _ from 'underscore'

export default class Gradebook extends Collection {
  /*
   * Allows sorting by multiple attributes.
   * sortBy should be in the form [[attr1, "DESC"], [attr2, "ASC"]]
   * Note: DESC sorting will only work on numeric types
   */
  multiSort (sortBy) {
    let sortedGrades = this.toArray()
    sortBy.reverse().forEach(function (sort) {
      let direction = 1
      if (sort[1] === 'DESC') { direction = -1 }

      sortedGrades = _.sortBy(sortedGrades, function (item) {
        const value = item.get(sort[0])

        if (value) {
          if (_.isNumber(value)) {
            return direction * value
          } else {
            return value.toLowerCase()
          }
        }
      })
    })

    this.reset(sortedGrades, { silent: true })

    return this
  }
}
